<template>
 <div style="background-color:#F2F2F2 !important">
  <transition name="fade">
    <div
      v-if="load === false && show"
      class="mt-3"
      style="background-color:#F2F2F2 !important"
      max-width="1600"

    >
      <v-slide-group active-class="success" v-if="items.length" style="background-color:#F2F2F2 !important">
        <v-slide-item v-for="(item, i) in items" :key="i" v-slot="{ active }" class="mb-2" >
          <v-card
            :color="active ? undefined : 'lighten-1'"
            class="pa-3 mr-5 d-flex-top-bottom"
            width="200"
            flat
            tile
            height="270"
            @click="$router.push(`/C/reward/detail/${item.rewardId}`)"
          >
            <v-img
              :style="item.quotaCode <= 0 ? 'opacity: 0.5;' : null"
              :src="item.pictureUrl"
              style="border-radius: 6px"
              height="180px"
              v-if="newData"
              @click="$router.push(`/C/reward/detail/${item.rewardId}`)"
            >
              <div v-if="item.levelNm !== 'All Level' && item.quotaCode > 0">
                <div
                  :style="
                    'width: 150px;' +
                    'height: 4px;' +
                    'transform: rotate(-30deg);' +
                    'position:absolute;' +
                    'top:13px;' +
                    'left:-50px;' +
                    'background-color:' +
                    item.color
                  "
                ></div>
                <div
                  :style="`width: 180px;height: 4px;background-color: ${item.color};transform: rotate(-30deg);position:absolute;top:24px;left:-20px;`"
                ></div>
                <div
                  :style="`position:absolute;left:-20px;top:10px;width:130px;background-color:${item.color};transform: rotate(-30deg);text-align:center;color:white;text-shadow: 1px 1px #000000; `"
                >
                  {{ item.levelNm }}
                </div>
              </div>
            </v-img>
            <div
              v-if="item.quotaCode <= 0"
              class="soldout"
            >
              สินค้าหมด
            </div>
            <div class="bold headline2">
              <div
                class="py-3 pb-0"
                style="font-size: 15px;"
                v-if="$i18n.locale === 'th' || item.nameEng === '' || item.nameEng === null"
                >{{ item.name.substring(0, 18)  }}
              </div>
              <div
                class="py-3 pb-0"
                style="font-size: 15px;"
                v-else-if="$i18n.locale === 'en'"
                >{{ item.nameEng.substring(0, 18) }}
              </div>
              <div class="w-100 d-flex justify-content-end mt-2">
                <v-chip
                  v-if="newData && item.supply !== 'admin'"
                  class="ml-n1 mt-n1 pa-2"
                  :color="isTargetShop? '#ffa300' : $bgColor"
                >
                <div style="display: flex; align-items: center; gap: 4px;">
                  <!-- ราคาเดิม (ขีดทับถ้ามี resale) -->
                  <strong class="text-center"
                  :style="{'color': item.resale && item.resale > 0 ? 'red' : chipTextColor, 'text-decoration': (item.resale && item.resale > 0) ? 'line-through' : 'none', 'font-size': (item.resale && item.resale > 0) ? '12px' : 'inherit'}"
                      >
                      {{ formatNumber(item.point) }}
                    </strong>

                  <!-- ราคาลด (ถ้ามี) -->
                  <strong
                    v-if="item.resale && item.resale > 0"
                    class="text-center"
                    :style="{'color': chipTextColor}">
                    {{ formatNumber(item.resale) }}
                  </strong>

                  <!-- ไอคอน -->
                  <img
                      v-if="profile.pictureUrl"
                      style="
                        border-color: white;
                        height: 20px;
                      "
                      alt="Avatar"
                      :src="pointIcon"
                    />
                </div>
                </v-chip>
                <v-chip
                  v-if="newData && item.supply === 'admin'"
                  class="ma-2 ml-n1 mt-n1"
                :color="isTargetShop? '#ffa300' : 'white'"
                  style="position: absolute; top: 140px; right: 5px"
                >
                  <div style="display: flex;align-items: center;">
                    <img
                        v-if="profile.pictureUrl"
                        style="
                          border-color: white;
                          height: 20px;
                          margin-right: 4px;
                        "
                        alt="Avatar"
                        :src="require('@/assets/coin.png')"
                      />
                      <!-- <div v-if="item.resale && item.resale > 0">
                        <strong class="text-center" color="#181446" style="text-decoration: line-through;color: grey;margin-left: 4px;font-size: 13px;"
                          >{{ formatNumber(item.levelSettingsReward) }}
                        </strong>
                      </div> -->
                      <div>
                        <strong class="text-center" :style="{'color': isTargetShop ? '#FFF' : '#181446'}"
                          >{{ findPointToRedeem(item.levelSettingsReward) }}
                        </strong>
                      </div>
                  </div>
                </v-chip>
              </div>
            </div>

            <v-row class="fill-height" align="center" justify="center">
              <v-scale-transition>
                <v-icon
                  v-if="active"
                  color="white"
                  size="48"
                ></v-icon>
              </v-scale-transition>
            </v-row>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </div>
    </transition>
 </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'MostPopular',
  data () {
    return {
      items: null,
      profile: null,
      session: this.$session.getAll(),
      DateNow: new Date(),
      load: true,
      show: false,
      shopId: null
    }
  },
  computed: {
    newData () {
      return this.GET_MEMBERINFO()
    },
    isTargetShop () {
      return this.$isTargetShop()
    },
    chipTextColor () {
      return this.isTargetShop ? '#000' : (this.HEXTHEMELMGLog(this.$bgColor) ? '#FFF' : this.$bgColor3)
    },
    pointIcon () {
      if (this.isTargetShop) {
        return this.$images.ChubbIconReward
      }
      if (this.checkpushCustom()) {
        return this.HEXTHEMELMG(this.$bgColor) ? this.$images.point : this.$images.pointWhite
      }
      return require('@/assets/coin.png')
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getReward()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    findPointToRedeem (item) {
      try {
        const levelSettings = JSON.parse(item)
        if (Array.isArray(levelSettings)) {
          const matched = levelSettings.find(data =>
            data.levelId.toString() === this.newData.levelId && data.enabled === true
          )
          return matched ? matched.points : null
        }

        return null
      } catch (error) {
        console.error('findPointToRedeem error', error)
      }
    },
    async getReward () {
      try {
        const result = await axios.get(this.DNS_IP + '/reward/getColor?RECORD_STATUS=N', { headers: {lineUserId: this.profile.userId, lineId: this.profile.userId, shopId: this.shopId} })
        // const result = await this.callBeTaskAPI(
        //   'get',
        //   '/reward/getColor?RECORD_STATUS=N'
        // )
        // result.data.map(item => console.log('fffff', item.expireTypeReward === 'FixDate' && moment(this.DateNow).format('YYYY-MM-DD') >= moment(item.startDate).format('YYYY-MM-DD') && moment(this.DateNow).format('YYYY-MM-DD') < moment(item.endDate).format('YYYY-MM-DD')))
        // console.log(moment(this.DateNow).format('YYYY-MM-DD'))
        if (Array.isArray(result.data)) {
          let a = result.data.filter(item => item.expireTypeReward === 'FixDate' && moment(this.DateNow).format('YYYY-MM-DD') >= moment(item.startDate).format('YYYY-MM-DD') && moment(this.DateNow).format('YYYY-MM-DD') < moment(item.endDate).format('YYYY-MM-DD'))
          result.data.map(item => item.expireTypeReward === 'Redeem' ? a.push(item) : null)
          this.items = a.sort((a, b) => { return a.point - b.point })
          this.items = this.items.filter(item => item.showReward !== 'False')
          this.items = this.items.filter(item => item.rewardId !== 338).filter((item2) => {
            if (item2.supply === 'admin') {
              if (item2.levelSettingsReward) {
                const levelSettings = JSON.parse(item2.levelSettingsReward)

                if (Array.isArray(levelSettings)) {
                  return levelSettings.some(data =>
                    data.levelId.toString() === this.newData.levelId && data.enabled === true
                  )
                }
              } else {
                return item2
              }
            } else {
              return item2
            }
          }) // สิทฺธิชิงโชคลิน
          setTimeout(() => {
            this.load = false
          }, 500)
          this.show = true
        }
        this.$checkGetReward = true
      } catch (err) {
        console.error('err', err)
      }
    }
  }
}
</script>
<style scoped>
#primary {
  background-color: #181446;
}
.v-sheet.v-card {
    border-radius: 14px;
    background-color: white !important;
}
.skeleton {
  opacity: 0.7;
  animation: skeleton-loading 5s linear infinite alternate;
}

.skeleton-text {
  width: 100%;
  height: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 0.125rem;
}

.skeleton-text:last-child {
  margin-bottom: 0;
  width: 80%;
}

@keyframes skeleton-loading {
  0% {
    background-color: #fff;
  }

  100% {
    background-color: #fff;
  }
}
.v-slide-group__wrapper{
  padding-left: 20px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.soldout{
 position: absolute;
                left: 0px;
                top: 27px;
                text-align: center;
                color: #fff;
                background-color: red;
                width: 100px;
                border-style: solid;
                border-color: #fff;
                border-width: 2px;
                border-left-style: none;
                border-top-right-radius: 8px;
                border-bottom-right-radius: 8px;
}
.d-flex-top-bottom{
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important
}
</style>



// WEBPACK FOOTER //
// src/components/Layouts/RewardCard.vue